import PubSub from "pubsub-js";
import gsap from 'gsap';

var NavBar = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-NavBar',
	};

	$.extend(true, this.options, options);

};

NavBar.prototype.init = function() {

	var self = this;

	this.$hamburger = this.options.$el.find(`.${self.options.baseClass}__hamburger`);
	this.$hamburgerLines = this.options.$el.find(`.${self.options.baseClass}__hamburger span`);
	// this.$linkItems = this.options.$el.find(`.${self.options.baseClass}__linkItem__sublinksWrapper`);
	this.$subnavs = this.options.$el.find(`.atom-NavigationPrimary__linkItem__sublinksWrapper`);
	this.$linkItemsWithSubnavs = this.$subnavs.closest(`.atom-NavigationPrimary__linkItem`);

	this.initAnimationTimelines();
	this.initSubnavs();

	this.$hamburger.on('click', function() {

		self.hamburgerOutTimeline.restart();

	});

	PubSub.subscribe('NavBar:showHamburger', function() {
	    
		self.hamburgerInTimeline.restart();

	});

};

NavBar.prototype.initAnimationTimelines = function() {

	var self = this;

	this.hamburgerOutTimeline = gsap.timeline(
		{
			paused: true
		}
	)
	.to(this.$hamburgerLines,
		{
			duration: 0.25,
			top: 9,
			ease: "power1.inOut"
		}
	)
	.to(this.$hamburgerLines,
		{
			duration: 0.25,
			width: 0,
			ease: "power3.in"
		},
		">-0.05"
	)
	.call(function() {
		PubSub.publish('NavOverlay:show');
	}, null, ">-0.05");

	this.hamburgerInTimeline = gsap.timeline(
		{
			paused: true
		}
	)
	.to(this.$hamburgerLines,
		{
			duration: 0.25,
			width: 20,
			ease: "power3.out"
		}
	)
	.to(this.$hamburgerLines.eq(0),
		{
			duration: 0.25,
			top: 0,
			ease: "power1.inOut"
		},
		">-0.1"
	)
	.to(this.$hamburgerLines.eq(2),
		{
			duration: 0.25,
			top: 18,
			ease: "power1.inOut"
		},
		"<"
	)
	;

};

NavBar.prototype.initSubnavs = function() {

	var self = this;

	this.$linkItemsWithSubnavs.each(function() {

		var $subnav = $(this).find(`.atom-NavigationPrimary__linkItem__sublinksWrapper`);

		gsap.set($(this).find(`.atom-NavigationPrimary__linkItem__sublinksWrapper`), {
			xPercent: -50,
		});

		var subnavTimeline = gsap.timeline({
			paused: true,
		})
		.set($(this).find(`.atom-NavigationPrimary__linkItem__sublinksWrapper`), {
			visibility: 'visible',
			paddingTop: 30,
			zIndex: 2,
		})
		.to($(this).find(`.atom-NavigationPrimary__linkItem__sublinksWrapper`), {
			opacity: 1,
			paddingTop: 24,
			duration: 0.35,
		});

		$(this).on({

			mouseenter: function () {
				subnavTimeline.timeScale(1).play();
			},
		
			mouseleave: function () {
				subnavTimeline.timeScale(1.5).reverse();
			}

		})

	});

};

export default NavBar;
